export const BASE_PATH = '/book-your-move';
